import { Dropdown as DropdownAtom } from '@/components/atoms/Select'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'

export const Dropdown = (props) => {
  const {
    name,
    label,
    variant,
    icon,
    Height,
    readOnly,
    disabled,
    panelClassName,
    className,
    editable,
    dropdownIcon,
    Background,
    Width,
    onlyLineH,
    onClick, // Agrega onClick a las props
    style
  } = props

  const handleClick = (e) => {
    if (onClick) {
      onClick(e) // Llama al onClick pasado como prop
    }
  }

  return (
    <div
      className={`${styles.dropdown} ${styles[variant]} ${icon && styles.dropdown_icon} ${className}`}
      onClick={handleClick} // Agrega el evento onClick al contenedor del Dropdown
    >
      {label && <label htmlFor={name} className={`${onlyLineH && styles.onlyLineH}`}>{label}</label>}
      {icon && <i className={`${styles.icon_left} ${icon}`} />}
      <DropdownAtom
        {...props}
        panelClassName={`${styles[variant]} ${panelClassName}`}
        invalidClassName={styles.invalid}
        invalidMessageClassName={styles.invalid_message}
        className={`${readOnly ? styles.readonly : ''} ${disabled ? styles.disabled : ''}`}
        style={{ height: Height, background: Background, width: Width, ...style }}
        editable={editable}
        dropdownIcon={dropdownIcon}
      />
    </div>
  )
}

Dropdown.defaultProps = {
  name: '',
  label: '',
  variant: 'primary',
  className: '',
  dropdownIcon: <i className='i-arrow-down-dark' />,
  style: {}
}

Dropdown.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func, // Define onChange como una función en las propType
  onClick: PropTypes.func,
  dropdownIcon: PropTypes.element,
  style: PropTypes.object
}
